"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterActions = void 0;
var react_1 = require("react");
var IFilterAction_1 = require("../../../../../../../../interfaces/IFilterAction");
var useSearchDebounce_1 = require("../../../../../../../../hooks/useSearchDebounce");
var get_building_units_thunk_1 = require("../../../../../../../../reducers/slices/lets_cue/units/thunks/get_building_units_thunk");
var react_redux_1 = require("react-redux");
var pages_1 = require("../../../../../../../../constants/pages");
function useFilterActions() {
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, useSearchDebounce_1.useSearchDebounce)(), search = _a[0], setSearch = _a[1];
    var _b = (0, react_1.useState)(null), buildingName = _b[0], setBuildingName = _b[1];
    var _c = (0, react_1.useState)(null), buildingID = _c[0], setBuildingID = _c[1];
    var _d = (0, react_1.useState)(null), status = _d[0], setStatus = _d[1];
    var handleSearch = (0, react_1.useCallback)(function (searchString) {
        setSearch(searchString);
    }, []);
    (0, react_1.useEffect)(function () {
        dispatch((0, get_building_units_thunk_1.get_building_units_thunk)(__assign(__assign({}, pages_1.initialPaginationValues), { search_string: search })));
    }, [search]);
    var filterActions = (0, react_1.useMemo)(function () { return [
        {
            type: IFilterAction_1.FilterTypeEnum.Input,
            key: "name",
            label: "Building Name",
            value: buildingName,
            onChange: setBuildingName,
            onSearch: handleSearch,
        },
        {
            type: IFilterAction_1.FilterTypeEnum.Input,
            key: "building_id",
            label: "Building Number",
            value: buildingID,
            onChange: setBuildingID,
            onSearch: handleSearch,
        },
        {
            type: IFilterAction_1.FilterTypeEnum.Input,
            key: "status",
            label: "Status",
            value: status,
            onChange: setStatus,
            onSearch: handleSearch,
        },
    ]; }, [
        buildingName,
        buildingID,
        status,
    ]);
    var resetFilters = (0, react_1.useCallback)(function () {
        setBuildingName(null);
        setBuildingID(null);
        setStatus(null);
        setSearch("");
    }, []);
    (0, react_1.useEffect)(function () {
        resetFilters();
    }, []);
    return (0, react_1.useMemo)(function () { return ({
        filterActions: filterActions,
    }); }, [filterActions]);
}
exports.useFilterActions = useFilterActions;
